import { FC } from "react";
import { Box, Text } from "@storyofams/react-ui";
import { useShopify } from "~context";
import { TypeSwitch } from "~components/account/TypeSwitch";
import { ProductByHandleQuery } from "~lib/shopify/sdk";

interface PriceProps {
  product: ProductByHandleQuery["productByHandle"];
  currentVariant: ProductByHandleQuery["productByHandle"]["variants"]["edges"][0]["node"];
  quantity: number;
  pickedOption?: string | null;
}

export const Price: FC<PriceProps> = ({
  currentVariant,
  product,
  quantity,
  pickedOption,
}) => {
  const { countryCode, customerCompanyId, isB2B } = useShopify();
  const autoDiscount =
    product?.autoDiscount?.value && product?.autoDiscount?.value !== "0"
      ? 1 - Number(product?.autoDiscount?.value) / 100
      : null;
  const getPrices = () => {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const location = countryCode ? countryCode : locale;
    let collection = product?.collections?.edges?.find(({ node }) =>
      node?.title?.includes(location.toUpperCase())
    );
    if (!collection)
      collection = product?.collections?.edges?.find(({ node }) =>
        node?.title?.includes("NL")
      );
    const tax = 1 + Number(collection?.node.title?.replace(/[^\d]/g, "")) / 100;
    console.log(tax);
    const prices = currentVariant?.quantityPriceBreaks?.nodes.sort(
      (a, b) => +b?.minimumQuantity - +a?.minimumQuantity
    );
    if (pickedOption && !currentVariant) {
      const variantsByOption = product.variants.edges.filter(
        (item) => item.node.selectedOptions[0].value === pickedOption
      );
      const prices = variantsByOption
        .map((item) => item.node.priceV2.amount)
        .sort((a, b) => a - b);
      const minPrice = prices[0];
      const maxPrice = prices[prices.length - 1];
      if (autoDiscount)
        return {
          taxPrice:
            minPrice === maxPrice
              ? `€${((minPrice / tax) * autoDiscount).toFixed(2)}`
              : `€${((minPrice / tax) * autoDiscount).toFixed(2)} - ${(
                  maxPrice *
                  tax *
                  autoDiscount
                ).toFixed(2)}`,
          сompareAt: null,
          price:
            minPrice === maxPrice
              ? `€${(minPrice * autoDiscount).toFixed(2)}`
              : `€${(minPrice * autoDiscount).toFixed(2)} - ${(
                  maxPrice * autoDiscount
                ).toFixed(2)}`,
          taxCompareAt: null,
        };
      else
        return {
          taxPrice:
            minPrice === maxPrice
              ? `€${(minPrice / tax).toFixed(2)}`
              : `€${(minPrice / tax).toFixed(2)} - ${(maxPrice / tax).toFixed(
                  2
                )}`,
          сompareAt: null,
          price:
            minPrice === maxPrice
              ? `€${(minPrice * 1).toFixed(2)}`
              : `€${(minPrice * 1).toFixed(2)} - ${(maxPrice * 1).toFixed(2)}`,
          taxCompareAt: null,
        };
    }
    if (customerCompanyId && prices && isB2B) {
      const getPriceByQuantity = () => {
        for (let tier of prices) {
          if (quantity >= tier.minimumQuantity) {
            return tier.price.amount;
          }
        }
        return currentVariant.priceV2.amount;
      };
      const price = getPriceByQuantity();
      return {
        taxPrice: "€" + (price / tax).toFixed(2),
        сompareAt: null,
        price: "€" + (price * 1).toFixed(2),
        taxCompareAt: null,
      };
    } else if (autoDiscount && currentVariant) {
      return {
        taxPrice:
          "€" +
          ((currentVariant.priceV2.amount / tax) * autoDiscount).toFixed(2),
        сompareAt: "€" + (currentVariant.priceV2.amount * 1).toFixed(2),
        price: "€" + (currentVariant.priceV2.amount * autoDiscount).toFixed(2),
        taxCompareAt:
          "€" + ((currentVariant.priceV2.amount / tax) * 1).toFixed(2),
      };
    } else if (currentVariant?.compareAtPriceV2) {
      return {
        taxPrice: "€" + (currentVariant.priceV2.amount / tax).toFixed(2),
        сompareAt:
          "€" + (currentVariant.compareAtPriceV2.amount * 1).toFixed(2),
        price: "€" + currentVariant.priceV2.amount,
        taxCompareAt:
          "€" + ((currentVariant.compareAtPriceV2.amount / tax) * 1).toFixed(2),
      };
    } else if (currentVariant) {
      return {
        taxPrice: "€" + (currentVariant.priceV2.amount / tax).toFixed(2),
        сompareAt: null,
        price: "€" + (currentVariant.priceV2.amount * 1).toFixed(2),
        taxCompareAt: null,
      };
    } else {
      const prices = product.variants.edges
        .map((item) => item.node.priceV2.amount)
        .sort((a, b) => a - b);
      const minPrice = prices[0];
      const maxPrice = prices[prices.length - 1];
      if (autoDiscount)
        return {
          taxPrice:
            minPrice === maxPrice
              ? `€${((minPrice / tax) * autoDiscount).toFixed(2)}`
              : `€${((minPrice / tax) * autoDiscount).toFixed(2)} - ${(
                  maxPrice *
                  tax *
                  autoDiscount
                ).toFixed(2)}`,
          сompareAt: null,
          taxCompareAt: null,
          price:
            minPrice === maxPrice
              ? `€${(minPrice * autoDiscount).toFixed(2)}`
              : `€${(minPrice * autoDiscount).toFixed(2)} - ${(
                  maxPrice * autoDiscount
                ).toFixed(2)}`,
        };
      else
        return {
          taxPrice:
            minPrice === maxPrice
              ? `€${(minPrice / tax).toFixed(2)}`
              : `€${(minPrice / tax).toFixed(2)} - ${(maxPrice / tax).toFixed(
                  2
                )}`,
          сompareAt: null,
          taxCompareAt: null,
          price:
            minPrice === maxPrice
              ? `€${(minPrice * 1).toFixed(2)}`
              : `€${(minPrice * 1).toFixed(2)} - ${(maxPrice * 1).toFixed(2)}`,
        };
    }
  };
  const { taxPrice, сompareAt, price, taxCompareAt } = getPrices();
  return (
    <Box
      display="flex"
      flexDirection={["column", "row"]}
      justifyContent="space-between"
      alignItems={["start", "end"]}
      mb={[1, 2]}
    >
      {price && !price.includes("NaN") && (
        <Box width={"max-content"} order={[1, 0]}>
          <Text fontSize={"14px"} color="grey600" mb={1}>
            Prijs
          </Text>
          <Box
            backgroundColor={"#EEE3D7"}
            px={"16px"}
            py={"11.5px"}
            borderRadius={"6px"}
          >
            <Text
              display={"inline"}
              whiteSpace={"nowrap"}
              fontWeight={600}
              lineHeight={"140%"}
            >
              {сompareAt && (
                <Text
                  opacity={"40%"}
                  display={"inline"}
                  textDecoration={"line-through"}
                  mr="3px"
                >
                  {сompareAt}
                </Text>
              )}
              {`${price} incl. btw`}
            </Text>
            <Box mt="2px" display={"flex"} />
            {taxCompareAt && !taxCompareAt.includes("NaN") && (
              <Text
                display={"inline"}
                fontSize={"14px"}
                opacity={"40%"}
                textDecoration={"line-through"}
                mr="3px"
                lineHeight={"140%"}
                whiteSpace={"nowrap"}
                color="#1D1D1BCC"
              >
                {`${taxCompareAt}`}
              </Text>
            )}
            {taxPrice && !taxPrice.includes("NaN") && (
              <Text
                display={"inline"}
                fontSize={"14px"}
                lineHeight={"140%"}
                whiteSpace={"nowrap"}
                color="#1D1D1BCC"
              >
                {`${taxPrice} excl. btw`}
              </Text>
            )}
          </Box>
        </Box>
      )}
      {customerCompanyId && <TypeSwitch />}
    </Box>
  );
};
